import { __module as defineProperty } from '../../../../_virtual/defineProperty.js';
import './toPropertyKey.js';
import { exports as toPropertyKeyExports } from '../../../../_virtual/toPropertyKey.js';

(function (module) {
	var toPropertyKey = toPropertyKeyExports;
	function _defineProperty(e, r, t) {
	  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
	    value: t,
	    enumerable: !0,
	    configurable: !0,
	    writable: !0
	  }) : e[r] = t, e;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (defineProperty));
//# sourceMappingURL=defineProperty.js.map
